import { c as _c } from "react/compiler-runtime";
import { CAMPAIGNS_API } from 'modules/campaigns/api/constants';
import { CampaignStepApiInterface, MailingDeliveryStatsApiInterface } from 'modules/campaigns/campaign-steps/types/campaign-step-interface';
import { CampaignId } from 'modules/campaigns/types/campaign-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
interface UseCampaignsInterface extends SwrPaginationInterface {
  campaignId: CampaignId;
}
export function useCampaignSteps(t0) {
  const $ = _c(14);
  const {
    campaignId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.get
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useFetch(t2);
  let t3;
  if ($[2] !== campaignId || $[3] !== user) {
    t3 = () => {
      if (user) {
        return [`${CAMPAIGNS_API}/${campaignId}/steps/list`, RequestModuleEnum.CampaignStep];
      }
    };
    $[2] = campaignId;
    $[3] = user;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      revalidateIfStale: true
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data: campaignStepsData,
    mutate,
    isValidating: isCampaignStepsDataValidating
  } = useControlledSwr(t3, fetcher, t4);
  let t5;
  if ($[6] !== campaignId || $[7] !== user) {
    t5 = () => {
      if (user) {
        return [`${CAMPAIGNS_API}/${campaignId}/steps/count`, RequestModuleEnum.CampaignStep];
      }
      return null;
    };
    $[6] = campaignId;
    $[7] = user;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data: counter
  } = useControlledSwr(t5, baseFetcher);
  let t6;
  if ($[9] !== campaignStepsData || $[10] !== counter || $[11] !== isCampaignStepsDataValidating || $[12] !== mutate) {
    t6 = {
      campaignStepsData,
      mutate,
      counter,
      isCampaignStepsDataValidating
    };
    $[9] = campaignStepsData;
    $[10] = counter;
    $[11] = isCampaignStepsDataValidating;
    $[12] = mutate;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}